
<!-- 商品分类下拉选择组件 -->
<template>
  <el-cascader clearable :placeholder="placeholder || '请选择商品分类'" :props="propsObj" v-model="watchCategoryId" :options="backEndClass"
    :show-all-levels="true" :disabled="isDisabled" ref="selectTree" @change="categoryChange">
    <template slot-scope="{node, data}">
      <span @click.stop="categoryClick(node, data)">{{ data.categoryName }}</span>
    </template>
  </el-cascader>
</template>

<script>
import { getCategoriesSelectList } from '@/api/shop/shopTypeManage'
export default {
  name: 'CategorySelect',
  props: ['categoryId', 'channelCode', 'channelCodes', 'isFreshCategory', 'isDisabled', 'placeholder'],
  data() {
    return {
      watchCategoryId: '',
      propsObj: {
        label: 'categoryName',
        value: 'categoryId',
        checkStrictly: true,
        emitPath: false
      },
      backClass: [], //
      backEndClass: [], // 分类数据
    }
  },
  watch: {
    categoryId: {
      handler(value) {
        this.watchCategoryId = value
      },
      immediate: true
    },
    channelCode(value) {
      if (value) {
        this.getClassify(value)
      }
    },
    channelCodes(value) {
      if (value) {
        this.getClassify(value)
      }
    },
    isFreshCategory(value) {
      if (value) {
        this.getClassify()
      }
    }
  },
  mounted() {
    this.getClassify()
  },
  methods: {
    getClassify() {
      const pamers = {}
      if (this.channelCodes && this.channelCodes.length) {
        pamers.channelCodes = this.channelCodes || []
      } else {
        pamers.channelCode = this.channelCode || ''
      }
      getCategoriesSelectList(pamers).then(res => { // 获取后端分类数据
        this.dataList = res.data.categoriesSelectDtoList
        const data = []
        const child = []

        if (pamers.channelCode) { // 如果存在渠道id，去校验分类id是否在改渠道下面的数据
          let isExistence = false // 分类原始数据是否存在父组件传过来的分类ID
          res.data.categoriesSelectDtoList.every((item) => {
            if (item.categoryId == this.watchCategoryId) {
              isExistence = true
              return false
            } else {
              isExistence = false
              return true
            }
          })
          if (!isExistence) {
            this.$emit('changeCascader', '') // 如果不存在父组件传过来的分类id，就将父组件中的分类id设置为空
          }
        }

        res.data.categoriesSelectDtoList.forEach((item) => {
          if (item.level === 1) {
            data.push(item)
          } else {
            child.push(item)
          }
        })



        data.forEach(item => {
          this.setShowCategoriesTree(item, child)
        })

        this.backEndClass = data
      })
    },
    // 分类格式化
    setShowCategoriesTree(obj, child) {
      const reg = new RegExp(`^${obj.categoryId}`)
      child = child.filter((item) => {
        if (obj.level === item.level - 1 && reg.test(item.categoryId)) {
          obj.children = obj.children || []
          obj.children.push(item)
          return false
        }
        return true
      })
      obj.children && obj.children.forEach((item) => {
        this.setShowCategoriesTree(item, child)
      })
    },
    categoryClick(node, data) { // 分类选择
      const selectTree = this.$refs.selectTree
      if (selectTree && node.pathNodes) {
        this.backClass = node.pathNodes.map((k) => k.value)
        selectTree.dropDownVisible = false
        this.watchCategoryId = node.value
        this.$emit('changeCascader', node.value, node.level)
      }
      console.log(data)
    },
    categoryChange(value) { // 分类单选按钮选择
      const selectTree = this.$refs.selectTree
      selectTree.dropDownVisible = false
      this.watchCategoryId = value
      if(value){
        let level = this.dataList.filter(v => v.categoryId == value)[0].level
        this.$emit('changeCascader', value, level)
      }else{
        this.$emit('changeCascader', value, '')
      }
    },
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/components/CategorySelect.vue